import { render } from "./Submit.vue?vue&type=template&id=00b6e22d&scoped=true&ts=true"
import script from "./Submit.vue?vue&type=script&lang=ts"
export * from "./Submit.vue?vue&type=script&lang=ts"

import "./Submit.vue?vue&type=style&index=0&id=00b6e22d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b6e22d"]])

export default __exports__